import w from "./index.es300.js";
import a from "./index.es301.js";
function h(e) {
  var i = e.stickyRowsCount, s = e.stickyColumnsCount, r = e.showGridLines, n = e.rightToLeft;
  if (!i && !s && r !== !1 && !n)
    return "";
  var t = "", o = {
    tabSelected: 1,
    workbookViewId: 0
  };
  r === !1 && (o.showGridLines = !1), n && (o.rightToLeft = 1);
  var u = {
    ySplit: i || 0,
    xSplit: s || 0,
    topLeftCell: w(s || 0, (i || 0) + 1),
    activePane: "bottomRight",
    state: "frozen"
  };
  return t += "<sheetViews>", t += "<sheetView".concat(a(o), ">"), t += "<pane".concat(a(u), "/>"), t += "</sheetView>", t += "</sheetViews>", t;
}
export {
  h as default
};
//# sourceMappingURL=index.es269.js.map
